<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="用户ID" prop="userId">
            <div slot="label">
              <span style="margin-left: 40px">用户ID</span>
            </div>
            <el-input style="width: 232px" v-model="searchForm.userId" placeholder="请输入用户ID" clearable></el-input>
          </el-form-item>
          <el-form-item label="用户昵称" prop="username">
            <el-input style="width: 232px" v-model="searchForm.username" placeholder="请输入用户昵称"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="phone">
            <el-input style="width: 232px" v-model="searchForm.phone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <!-- <el-form-item label="用户等级" prop="brandId">
            <el-select
              v-model="searchForm.brandId"
              placeholder="请选择用户等级"
              filterable
              clearable
            >
              <el-option
                v-for="item in brandList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="是否购买商品" prop="hasShopping">
            <el-select style="width: 232px" v-model="searchForm.hasShopping" placeholder="请选择" filterable clearable>
              <el-option v-for="item in brandList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="加入时间" prop="joinTimeStart">
            <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="最近访问时间" prop="lastActiveTimeStart">
            <el-date-picker v-model="value2" style="width: 232px" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="绑定时间" prop="bindTimeStart">
            <el-date-picker v-model="value3" style="width: 232px" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="form-btn">
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <el-button type="primary" icon="el-icon-upload2" :loading="exporting" @click="exportFn">批量导出</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage" :page-size="page.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
    <el-dialog title="绑定记录" :visible.sync="isRecord" width="774px" :append-to-body="true">
      <template>
        <div>
          <div>
            <el-table :data="records" ref="multipleTable" :header-cell-style="{
              'text-align': 'left',
              background: '#F8F8F8',
              color: '#333333',
            }">
              <el-table-column label="绑定时间" width="200px">
                <template slot-scope="scope">
                  {{ scope.row.bindTime || '--' }}
                </template>
              </el-table-column>
              <el-table-column prop="goodsName" label="绑定用户">
                <template slot-scope="scope">
                  <div style="display: flex">
                    <img
                      :src="scope.row.avatarUrl ? scope.row.avatarUrl : require('../../../assets/icon_touxiang_106@2x.png')"
                      style="width: 64px; height: 64px; margin-right: 12px;border-radius: 50%;" alt="" />
                    <div style="
                    font-size: 14px;
                    min-height: 56px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  ">
                      <p style="color: #303033">{{ scope.row.username }}</p>
                      <p style="color: #303033">
                        ID：{{ scope.row.id }}
                      </p>
                      <p style="color: #303033">
                        电话：{{ scope.row.phone }}
                      </p>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="解绑时间" width="200px">
                <template slot-scope="scope">
                  {{ scope.row.unbindTime || '--' }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 24px">
          <div class="info-s" @click="isRecord = false">确定</div>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="更换绑定上级" :visible.sync="isBind" width="518px" :append-to-body="true">
      <div style="margin-left: 12px;">
        <!-- <div style="display: flex">
          <div style="line-height: 30px">用户信息</div>
          <div style="margin-left: 20px">
            <el-input placeholder="请输入用户信息" size="small" v-model="name"></el-input>
          </div>
          <div style="margin-left: 20px">
            <el-button type="primary" @click="searchUser()" size="small" :disabled="name == ''">查询</el-button>
          </div>
        </div> -->
        <div style="
          width: 454px;
          min-height: 150px;
          background: #F5F6FA;
          opacity: 1;">
          <div style="padding:24px 18px">
            <div style="display: flex;justify-content: space-between;">
              <div class="title-u">
                当前绑定上级</div>
              <div class="change" @click="searchUser('reset')" v-if="!selectData1.id">更换</div>
            </div>

            <div style="display: flex;margin-top:20px">
              <img
                :src="currentData.parent && currentData.parent.avatarUrl ? currentData.parent.avatarUrl || '--' : require('../../../assets/icon_touxiang_106@2x.png')"
                style="width:64px;height: 64px;border-radius: 50%;" />
              <div style="display: flex;flex-direction: column;justify-content: space-between;padding-left:20px">
                <div>{{ currentData.parent && currentData.parent.name ? currentData.parent.name : '--' }}</div>
                <div style="display: flex;">
                  <div>ID:{{ currentData.parent && currentData.parent.id ? currentData.parent.id : '--' }}</div>
                  <div style="margin-left:20px">电话：{{ currentData.parent && currentData.parent.phone ?
                    currentData.parent.phone : '--' }}</div>
                </div>
              </div>
            </div>
            <div style="margin-top:40px;" class="title-u" v-if="isChange && selectData1.id">上级更换为</div>
            <div style="display: flex;margin-top:20px;justify-content: space-between;padding-bottom:5px"
              v-if="isChange && selectData1.id">
              <div style="display: flex;">
                <img
                  :src="selectData1.avatarUrl ? selectData1.avatarUrl : require('../../../assets/icon_touxiang_106@2x.png')"
                  style="width:64px;height: 64px;border-radius: 50%;" />
                <div style="display: flex;flex-direction: column;justify-content: space-between;padding-left:20px">
                  <div>{{ selectData1.username || '--' }}</div>
                  <div style="display: flex;">
                    <div>ID:{{ selectData1.id || '--' }}</div>
                    <div style="margin-left:20px">电话：{{ selectData1.phone || '--' }}</div>
                  </div>
                </div>
              </div>
              <div class="change" @click="searchUser('reset')" style="margin-top:18px">更换</div>
              <!-- <div class="delete-u" @click="deleteS">删除</div> -->
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; justify-content: end; margin-top: 24px;margin-right:12px">
        <div class="info-q" @click="isBind = false">取消</div>
        <div class="info-s" @click="submitBind">确定</div>
      </div>

    </el-dialog>
    <el-dialog title="" :visible.sync="isUser" width="518px" :append-to-body="true">
      <template>
        <div>
          <div style="display: flex">
            <div style="line-height: 30px">用户信息</div>
            <div style="margin-left: 20px">
              <el-input placeholder="请输入用户信息" size="small" v-model="name"></el-input>
            </div>
            <div style="margin-left: 20px">
              <el-button type="primary" @click="searchUser()" size="small" :disabled="name == ''">查询</el-button>
            </div>
          </div>
          <div style="margin-top:18px">
            <el-table :data="lists" ref="multipleTable" :header-cell-style="{
              'text-align': 'left',
              background: '#F8F8F8',
              color: '#333333',
            }">
              <el-table-column prop="goodsName" label="用户信息">
                <template slot-scope="scope">
                  <div style="display: flex">
                    <img
                      :src="scope.row.avatarUrl ? scope.row.avatarUrl : require('../../../assets/icon_touxiang_106@2x.png')"
                      style="width: 64px; height: 64px; margin-right: 12px;border-radius: 50%;" alt="" />
                    <div style="
                    font-size: 14px;
                  
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    
                  ">
                      <p style="color: #303033">{{ scope.row.username }}</p>
                      <div style="display: flex;">
                        <p style="color: #303033;margin-right:10px">
                          ID：{{ scope.row.id }}
                        </p>
                        <p style="color: #303033">
                          电话：{{ scope.row.phone }}
                        </p>
                      </div>

                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot="header" slot-scope="scope">
                  <div style="text-align: center;">操作</div>
                </template>
                <template slot-scope="scope">
                  <div style="text-align: center;margin-left:10px">
                    <div class="btn-y" v-if="scope.row.isShow == true" @click="selectBind(scope.$index)">已选择</div>
                    <div class="btn-s" v-else @click="selectBind(scope.$index)">选择</div>
                  </div>

                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px;">
          <div class="info-q" @click="isUser = false">取消</div>
          <div class="info-s" @click="bindSave">确定</div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable,
  },
  data() {
    return {
      lists: [],
      name: '',
      isUser: false,
      isRecord: false,
      isBind: false,
      isChange: false,
      records: [
        {
          time: '2023-12-12 10:20:02',
          avatar: 'https://fenxiao.muruji.com/b4908f91ff7c4c75bb4bfd3f920709cc/6cdbbf91-4e0e-46c1-84c2-d03736b13e6b',
          name: 'cdd',
          id: '7777',
          phone: '150111111111'
        },
        {
          time: '2023-12-12 10:20:02',
          avatar: 'https://fenxiao.muruji.com/b4908f91ff7c4c75bb4bfd3f920709cc/6cdbbf91-4e0e-46c1-84c2-d03736b13e6b',
          name: 'cdd',
          id: '7777',
          phone: '150111111111'
        },
        {
          time: '2023-12-12 10:20:02',
          avatar: 'https://fenxiao.muruji.com/b4908f91ff7c4c75bb4bfd3f920709cc/6cdbbf91-4e0e-46c1-84c2-d03736b13e6b',
          name: 'cdd',
          id: '7777',
          phone: '150111111111'
        },
      ],
      dataList: {
        list: [
          { title: '用户管理', path: '', type: '0' },
          { title: '用户列表', path: '/userManagement/userList', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '用户列表', path: '', type: '0' },
          { title: '数据筛选', path: '', type: '1' }
        ]
      },
      list: [],
      searchForm: {
        userId: '', // 	
        username: '', // 	
        phone: '', // 	
        hasShopping: '', // 	
        joinTimeStart: '', // 	
        joinTimeEnd: '', // 	
        lastActiveTimeStart: '', // 	
        lastActiveTimeEnd: '', //
        bindTimeStart: '',
        bindTimeEnd: ''
      },
      searchForm1: {
        userId: '', // 	
        username: '', // 	
        phone: '', // 	
        hasShopping: '', // 	
        joinTimeStart: '', // 	
        joinTimeEnd: '', // 	
        lastActiveTimeStart: '', // 	
        lastActiveTimeEnd: '', //
        bindTimeStart: '',
        bindTimeEnd: ''
      },
      value1: [],
      value2: [],
      value3: [],
      brandList: [],
      columns: [
        { type: 'selection', minWidth: '80', },
        {
          label: '用户信息', prop: 'username', minWidth: '222',
          renderHeader: (h, scope) => {
            return (
              <div style="text-align:left">用户信息</div>
            )
          },
          render: (h, scope) => {
            let img = scope.row.avatarUrl ? scope.row.avatarUrl : require('../../../assets/icon_touxiang_106@2x.png')
            return (
              <div style="display:flex">
                <div>
                  <el-image style="width:64px;height:64px;border-radius:50%;" src={img} preview-src-list={[img]} lazy></el-image>
                </div>
                <div style="margin-left:8px">
                  <div style="text-align:left">昵称：{scope.row.username || '--'}</div>
                  <div style="text-align:left">ID：{scope.row.id || '--'}</div>
                  <div style="text-align:left">电话：{scope.row.phone || '--'}</div>
                </div>

              </div>
            )
          }
        },
        {
          label: '加入时间', prop: 'joinTime', minWidth: '150',
          renderHeader: (h, scope) => {
            return (
              <div style="text-align:left">加入时间</div>
            )
          },
          render: (h, scope) => {
            return (
              <div style="text-align:left">{scope.row.joinTime || '--'}</div>
            )
          }
        },
        {
          label: '最近访问时间', prop: 'lastActiveTime', minWidth: '150',
          renderHeader: (h, scope) => {
            return (
              <div style="text-align:left">最近访问时间</div>
            )
          },
          render: (h, scope) => {
            let lastActiveTime = scope.row.lastActiveTime ? scope.row.lastActiveTime : '--'
            return (
              <div style="text-align:left">
                <span>{lastActiveTime}</span>
              </div >
            )
          }
        },
        {
          label: '用户信息', prop: 'username', minWidth: '220',
          renderHeader: (h, scope) => {
            return (
              <div style="text-align:left">绑定上级</div>
            )
          },
          render: (h, scope) => {
            let img = scope.row.parent.avatarUrl ? scope.row.parent.avatarUrl : require('../../../assets/icon_touxiang_106@2x.png')
            return (
              <div style="display:flex">
                <div>
                  <el-image style="width:64px;height:64px;border-radius:50%;" src={img} preview-src-list={[img]} lazy></el-image>
                </div>
                <div style="margin-left:8px">
                  <div style="text-align:left">昵称：{scope.row.parent.name || '--'}</div>
                  <div style="text-align:left">ID：{scope.row.parent.id || '--'}</div>
                  <div style="text-align:left">电话：{scope.row.parent.phone || '--'}</div>
                </div>

              </div>
            )
          }
        },
        {
          label: '绑定时间', prop: 'bindTime', minWidth: '150',
          renderHeader: (h, scope) => {
            return (
              <div style="text-align:left">绑定时间</div>
            )
          },
          render: (h, scope) => {
            let bindTime = scope.row.parent.bindTime ? scope.row.parent.bindTime : '--'
            return (
              <div style="text-align:left">
                <span>{bindTime}</span>
              </div >
            )
          }
        },
        { label: '拥有粉丝数', prop: 'fansCount', minWidth: '100' },
        { label: '可提现佣金', prop: 'commission', minWidth: '100' },
        {
          label: '是否会员', prop: 'isMember', minWidth: '100',
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.isMemberL}</span>
              </div >
            )
          }
        },
        { label: '是否购买商品', prop: 'hasShopping', minWidth: '120' },
        {
          label: '操作',
          minWidth: '150',

          render: (h, scope) => {
            return (
              <div>
                <el-dropdown onCommand={($event) => { this.handleCommand($event, scope.row) }} placement="bottom">
                  <span class="el-dropdown-link" style="color: #4168e7;cursor: pointer;">
                    更多<i class="el-icon-arrow-down el-icon--right" style="color: #4168e7;cursor: pointer;"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" class="dropdown">
                    <el-dropdown-item command="look" onClick={() => { this.add('edit', scope.row.id) }}>查看</el-dropdown-item>
                    <el-dropdown-item command="change">更换绑定</el-dropdown-item>
                    <el-dropdown-item command="record">绑定记录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                {/* <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.todetail(scope.row) }}>查看</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:10px;margin-right:10px' onClick={() => { this.changeBind(scope.row) }}>更换绑定</span>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.lookRecord(scope.row) }}>绑定记录</span> */}
              </div >
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      exporting: false,
      currentData: {},
      selectData: {},
      selectData1: {}
    }
  },
  created() {
    this.getPageList()
  },
  methods: {
    submitBind() {
      if (!this.selectData1.id) {
        this.$message.warning('请选择绑定上级')
        return
      }
      let data = {
        parentId: this.selectData1.id,
        userId: this.currentData.id
      }
      this.axios.post('/admin/changeBind', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.$message.success('换绑成功')
            this.isBind = false
            // this.searchForm.username = ''
            this.getPageList()
          }
        })
    },
    deleteS() {
      this.isChange = false
      this.selectData1 = {}
    },
    bindSave() {
      this.selectData1 = this.selectData
      this.isUser = false
      this.isChange = true
    },
    selectBind(index) {
      for (let i = 0; i < this.lists.length; i++) {
        if (i == index) {
          this.lists[index].isShow = !this.lists[index].isShow
        } else {
          this.lists[i].isShow = false
        }
      }
      this.selectData = this.lists[index]
    },
    searchUser(val) {
      // this.$refs['searchForm'].resetFields()
      // this.value1 = []
      // this.value2 = []
      // this.searchForm.joinTimeStart = ''
      // this.searchForm.joinTimeEnd = ''
      // this.searchForm.lastActiveTimeStart = ''
      // this.searchForm.lastActiveTimeEnd = ''
      // this.searchForm.bindTimeStart = ''
      // this.searchForm.bindTimeEnd = ''
      this.isUser = true
      this.searchForm1.pageNo = 1;
      this.searchForm1.pageSize = 10000000;
      if (val == 'reset') {
        this.name = ''
      }
      this.searchForm1.username = this.name
      if (this.name == '') {
        this.lists = []
        return

      }
      this.axios.post('/users/getPageList', this.searchForm1)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            res.data.list.forEach(item => {
              if (item.id == this.currentData.parent.id) {
                item.isShow = true
              } else {
                item.isShow = false
              }
            })
            this.lists = res.data.list;

          }
        })
    },
    handleCommand(e, row) {
      console.log(e)
      if (e == 'look') {
        this.todetail(row)
      } else if (e == 'change') {
        this.changeBind(row)
      } else if (e == 'record') {
        this.lookRecord(row)
      }
    },
    changeBind(row) {
      this.isBind = true
      this.name = ''
      this.selectData1.id = ''
      console.log(row)
      this.currentData = row
    },
    lookRecord(row) {
      this.isRecord = true
      let data = {
        userId: row.id
      }
      this.axios.get('/admin/changeBindLog?userId=' + row.id)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.records = res.data

          }
        })
    },
    exportFn() {
      this.exporting = true
      if (this.value1 && this.value1.length > 0) {
        this.searchForm.joinTimeStart = this.value1[0];
        this.searchForm.joinTimeEnd = this.value1[1];
      } else {
        this.searchForm.joinTimeStart = ''
        this.searchForm.joinTimeEnd = ''
      }
      if (this.value2 && this.value2.length > 0) {
        this.searchForm.lastActiveTimeStart = this.value2[0];
        this.searchForm.lastActiveTimeEnd = this.value2[1];
      } else {
        this.searchForm.lastActiveTimeStart = ''
        this.searchForm.lastActiveTimeEnd = ''
      }
      if (this.value3 && this.value3.length > 0) {
        this.searchForm.bindTimeStart = this.value3[0]
        this.searchForm.bindTimeEnd = this.value3[1]
      } else {
        this.searchForm.bindTimeStart = ''
        this.searchForm.bindTimeEnd = ''
      }
      this.axios.post('/users/exportList', this.searchForm)
        .then(res => {
          console.log(res)
          this.exporting = false;
          if (res.code === 0) {
            this.downloadlink(res.data)
          }
        })
    },
    fetchData(type) {
      this.page.pageNo = 1;
      if (type == 'reset') {
        this.$refs['searchForm'].resetFields()
        this.value1 = []
        this.value2 = []
        this.value3 = []
        this.searchForm.joinTimeStart = ''
        this.searchForm.joinTimeEnd = ''
        this.searchForm.lastActiveTimeStart = ''
        this.searchForm.lastActiveTimeEnd = ''
      }
      if (this.value1 && this.value1.length > 0) {
        this.searchForm.joinTimeStart = this.value1[0];
        this.searchForm.joinTimeEnd = this.value1[1];
      } else {
        this.searchForm.joinTimeStart = ''
        this.searchForm.joinTimeEnd = ''
      }
      if (this.value2 && this.value2.length > 0) {
        this.searchForm.lastActiveTimeStart = this.value2[0];
        this.searchForm.lastActiveTimeEnd = this.value2[1];
      } else {
        this.searchForm.lastActiveTimeStart = ''
        this.searchForm.lastActiveTimeEnd = ''
      }
      if (this.value3 && this.value3.length > 0) {
        this.searchForm.bindTimeStart = this.value3[0]
        this.searchForm.bindTimeEnd = this.value3[1]
      } else {
        this.searchForm.bindTimeStart = ''
        this.searchForm.bindTimeEnd = ''
      }
      this.getPageList()
    },
    getPageList() {
      if (this.value1 && this.value1.length > 0) {
        this.searchForm.joinTimeStart = this.value1[0];
        this.searchForm.joinTimeEnd = this.value1[1];
      } else {
        this.searchForm.joinTimeStart = ''
        this.searchForm.joinTimeEnd = ''
      }
      if (this.value2 && this.value2.length > 0) {
        this.searchForm.lastActiveTimeStart = this.value2[0];
        this.searchForm.lastActiveTimeEnd = this.value2[1];
      } else {
        this.searchForm.lastActiveTimeStart = ''
        this.searchForm.lastActiveTimeEnd = ''
      }
      if (this.value3 && this.value3.length > 0) {
        this.searchForm.bindTimeStart = this.value3[0]
        this.searchForm.bindTimeEnd = this.value3[1]
      } else {
        this.searchForm.bindTimeStart = ''
        this.searchForm.bindTimeEnd = ''
      }
      this.searchForm.pageNo = this.page.pageNo;
      this.searchForm.pageSize = this.page.pageSize;
      this.axios.post('/users/getPageList', this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            res.data.list.forEach(item => {
              if (item.isMember == 0) {
                item.isMemberL = '否'
              } else {
                item.isMemberL = '是'
              }
            })
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    },
    onMultipleSelection(e) { },
    handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getPageList()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e;
      this.getPageList()
    },
    todetail(row) {
      this.$router.push({
        name: 'userDetail',
        query: {
          id: row.id
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.el-button--primary.is-disabled {
  background: #2D46EE;
  border: 1px solid #2D46EE;
}

.dropdown {
  background-color: red !important;
}

.change {
  width: 64px;
  height: 32px;
  background: #FFFFFF;
  border: 1px solid #2D46EE;
  opacity: 1;
  border-radius: 16px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 32px;
  color: #2D46EE;
  text-align: center;
  cursor: pointer;
}

.btn-y {
  width: 64px;
  height: 32px;
  background: #2D46EE;
  opacity: 1;
  border-radius: 16px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 32px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
}

.btn-s {
  width: 64px;
  height: 32px;
  background: #E9ECFE;
  opacity: 1;
  border-radius: 16px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 32px;
  color: #2D46EE;
  text-align: center;
  cursor: pointer;
}

.title-u {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 34px;
  color: #2D46EE;
}

.delete-u {
  width: 64px;
  height: 32px;
  background: #F63C56;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 32px;
  color: #FFFFFF;
  text-align: center;
  margin-top: 16px;
  opacity: 1;
  border-radius: 16px;
  cursor: pointer;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 37px;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }

  .form-btn {
    /deep/ .el-form-item__content {
      line-height: 36px;
      margin-left: 50px;
    }
  }
}

/deep/ .el-table__row {
  .el-table__cell {
    padding: 12px 0;
  }
}

/deep/ .el-table {
  color: #303033;
}
</style>
<style lang="scss">
.el-dropdown-menu .el-dropdown-menu__item:hover {
  background-color: white;
  color: #2D46EE;
}
</style>



